export default "__VITE_ASSET__CdYJlKg7__"